import europeanRecipes from './european';
import asianRecipes from './asian';
import americasRecipes from './americas';
import middleEastAfricaRecipes from './middleEastAfrica';
import indianMediterraneanRecipes from './indianMediterranean';
import specialtyRecipes from './specialty';
import familyBabyRecipes from './familyBaby';

const allSeedRecipes = [
  ...europeanRecipes,
  ...asianRecipes,
  ...americasRecipes,
  ...middleEastAfricaRecipes,
  ...indianMediterraneanRecipes,
  ...specialtyRecipes,
  ...familyBabyRecipes,
];

export default allSeedRecipes;

export {
  europeanRecipes,
  asianRecipes,
  americasRecipes,
  middleEastAfricaRecipes,
  indianMediterraneanRecipes,
  specialtyRecipes,
  familyBabyRecipes,
};
